import './MileStone.scss'
import { Spacer } from '../../atoms'
export default function MileStone() {
  return (
    <div className="mileStoneComp">
      <div className="goalBlock">
        <div className="row align-items-center">
          <div className="col-lg-3 mb-3">
            <span className="underTitle">
              Our main goal is to be a
            </span>
          </div>
          <div className="col-lg-9 d-flex flex-wrap">
            <div className="mainGoal">
              <div className="circle">
                <span className="underTitle">Multi-billion dollars marketcap project and fully controlled by the community [DAO]</span>
              </div>
            </div>
            <div className="mainTag">
              <div className="itemTag">Inflation Protection System</div>
              <div className="itemTag">Infrastructure Upgrade</div>
              <div className="itemTag">Strategic Partnership</div>
              <div className="itemTag">Disruptive Marketing</div>
              <div className="itemTag">Multi-chains ecosystem</div>
              <div className="itemTag">Stress Test Apps</div>
              <div className="itemTag">Algo Improvement</div>
              <div className="itemTag">Community Building</div>
              <div className="itemTag">Machine Learning</div>
              <div className="itemTag">Chat App Farming</div>
              <div className="itemTag">Voting Dashboard</div>
            </div>
          </div>
        </div>
      </div>
      <Spacer h={50} />
      <span className="underTitle">
        We know that the path will not be a straight line, but We will manage to get there.
      </span>
    </div>
  )
}
